module.exports = "/_next/static/images/Supplies-e4beeef480d21cbe9b24fc99d0c56666.png";